<template>
  <div style="min-width: 1300px;padding: 50px 0;">
  	<p style="text-align: center;font-size: 30px;">服务平台</p>
  	<p style="text-align: center;font-size: 15px;">Service platform</p>
  	<div style="overflow:hidden;margin-top: 50px;">
  		<div style="margin: auto;overflow:hidden;width: 1200px;">
  			<Card class="list-card" :bordered="false" @click.native="openJypt">
	        <div style="text-align:center">
	        	 <img src="@/assets/v2/icon/trading_icon.jpg" />
	           <h3 style="margin: 15px 0;">专利交易展示平台</h3>
	           <p style="font-size: 12px;">管理平台多用户多权限上下架</p>
	           <p style="font-size: 12px;">大量资源等你来</p>
	        </div>
	    	</Card>
	  		<Card class="list-card" :bordered="false" @click.native="opengzdjf">
	        <div style="text-align:center">
	        	 <img src="@/assets/v2/icon/paying_icon.jpg" />
	           <h3 style="margin: 15px 0;">专利代缴费服务</h3>
	           <p style="font-size: 12px;">提供专业代缴费服务</p>
	           <p style="font-size: 12px;">方便、快捷</p>
	        </div>
	    	</Card>
	    	<Card class="list-card" :bordered="false" @click.native="openRetrieval">
	        <div style="text-align:center">
	        	 <img src="@/assets/v2/icon/search_icon.jpg" />
	           <h3 style="margin: 15px 0;">检索咨询服务</h3>
	           <p style="font-size: 12px;">信息中心精准数据资源</p>
	           <p style="font-size: 12px;">专业的分析报告。</p>
	        </div>
	    	</Card>
	    	<Card class="list-card" :bordered="false" @click.native="openMetalcertificate">
	        <div style="text-align:center">
	        	 <img src="@/assets/v2/icon/certificate_icon.jpg" />
	           <h3 style="margin: 15px 0;">金属专利证书制作</h3>
	           <p style="font-size: 12px;">金属专利证书设计新颖、制作精美</p>
	           <p style="font-size: 12px;">适合收藏纪念。</p>
	        </div>
	    	</Card>
  		</div>

  	</div>
  </div>
</template>

<script>
export default {
  name: 'service',
  data:function(){
  	return {
  	}
  },
	components: {},
	methods:{

		openJypt:function(){
			//window.open("https://mzipatent.com:81/#/login?version=jyzs");
      window.open("https://zlxq.mzipatent.com/");
		},
		opengzdjf:function(){
		//	window.open("https://v1.mzipatent.com/resources/lib/login/djf.html");
			window.open("/#/v2/generationpayment");
		},
		openMetalcertificate:function(){
			window.open("/#/v2/metalcertificate");
		},
		openRetrieval:function(){
			window.open("/#/v2/retrieval");
		}
	}
}
</script>

<style scoped>
	.list-card{
		width:240px;float: left;margin: 10px;padding: 20px;cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/view/v2/index/service/index.vue